import React from 'react';
import './Motif.css';

const Motifs = ({ decisionData }) => {
    if (!decisionData) return null;

    return (
        <div id="motifs" className="content-section">
            {decisionData?.motifs ? (
                <p className="content-text">{decisionData?.motifs}</p>
            ) : (
                <p className="no-content-text">Aucun motif disponible pour cette décision.</p>
            )}
        </div>
    );
};

export default Motifs;